import { createFileRoute } from '@tanstack/react-router'
import { requireAllowedPersonalizedPlanSuperAdmin } from '@/lib/auth-guards'
import { SettingsBusiness } from '@/features/settings/business'

export const Route = createFileRoute('/_authenticated/settings/business')({
  beforeLoad: requireAllowedPersonalizedPlanSuperAdmin,
  component: SettingsBusiness,
})
